import {
  useAddBookmarkContent,
  useDeleteBookmarkContent,
  useGetContentDetail,
  useUpdateContentLikeCount,
} from './api';

import Toast from '@/components/Toast';
import { messages } from '@/consts/Messages';
import { mixpanelTrack } from '@/utils/mixpanel';
import { useSearchParams } from 'next/navigation';

export const useFooterData = () => {
  const id = +(useSearchParams().get('id') || 0);

  const { data, refetch } = useGetContentDetail();

  const { mutate: deleteContent } = useDeleteBookmarkContent();
  const { mutate: addContent } = useAddBookmarkContent();
  const { mutate: likeContent } = useUpdateContentLikeCount(refetch);

  const onClickBookMarkButton = async () => {
    mixpanelTrack('DiscoveryDetailModal_BookmarkButton', 'Clicked');

    if (data?.content.is_bookmarked) {
      deleteContent(+data?.content.id, {
        onSettled: () => {
          refetch();
        },
      });
      Toast.success(messages.BOOKMARK_DELETED_SUCCESSFUL);
      return;
    }

    addContent(+(data?.content.id || 0), {
      onSettled: () => {
        refetch();
      },
    });

    Toast.success(messages.BOOKMARK_ADDED_SUCCESSFUL);
  };

  const onClickLikeButton = async () => {
    mixpanelTrack('DiscoveryDetailModal_LikeButton', 'Clicked', {
      id: id,
    });

    likeContent({ id: data?.content.id || 0, like: !data?.content.is_like });
    refetch();
  };

  return {
    id,
    data,
    onClickBookMarkButton,
    onClickLikeButton,
  };
};
